import DashboardLayout from "components/layouts/dashboard-layout";
import React from "react";
import styled from "styled-components";
import Countries from "./components/countries";
import AllRelease from "./components/all-release";
import LastRelease from "./components/last-release";

const DashboardInsights = () => {
  return (
    <DashboardLayout>
      <>
        <LastRelease />
        <AllRelease />
        <Countries />
      </>
    </DashboardLayout>
  );
};

export default DashboardInsights;

const Main = styled.div`
  position: relative;
`;
